import React from "react";

function FAQBody() {
  return (
    <>
      <div className="container-fluid  p-4 body-font">
        <div
          className="row p-4"
          style={{
            width: "100vw",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="row img-fluid"
            style={{
              backgroundImage:
                "url(https://images.hertz.com/content/dam/hod/images/en-gb/static/FAQ_top.png)",
              backgroundSize: "cover",
            }}
          >
            <div className="col-xs-12 col-md-1"></div>
            <div className="col-xs-12 col-md-5">
              <br />
              <p className="h6">
                <b>Questions fréquentes</b>
              </p>
              <p className="h1">
                <b>En savoir plus</b>
              </p>
              <p>
                Nous comprenons que vous puissiez avoir des questions sur le
                fonctionnement de Hertz 24/7, des inquiétudes concernant vos
                factures ou que vous souhaitiez simplement savoir ce qu'il faut
                faire pour vous inscrire. Cette page répondra à ces questions.
              </p>

              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
            <div className="col-xs-12 col-md-4"></div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-md-3" style={{ textAlign: "center" }}>
            <br />
            <br />
            <p>
              <a href="#reg" style={{ textDecoration: "none" }}>
                Inscvription
              </a>
            </p>
            <hr />
            <p>
              <a href="#book" style={{ textDecoration: "none" }}>
                Votre réservation
              </a>
            </p>
            <hr />
            <p>
              <a href="#yj" style={{ textDecoration: "none" }}>
                Votre location
              </a>
            </p>
            <hr />
            <p>
              <a href="#bfi" style={{ textDecoration: "none" }}>
                Facturation, frais et assurance
              </a>
            </p>
            <hr />
            <p>
              <a href="#aob" style={{ textDecoration: "none" }}>
                Accidents/Pannes
              </a>
            </p>
            <hr />
            <p>
              <a href="#cg" style={{ textDecoration: "none" }}>
                Règles de bonne conduite
              </a>
            </p>
            <hr />
            <p>
              <a href="#cls" style={{ textDecoration: "none" }}>
                Contactez le support
              </a>
            </p>
            <hr />
          </div>

          <div className="col-xs-12 col-md-9" style={{ textAlign: "left" }}>
            <br />
            <br />

            <div className="accordion p-4" id="accordionFlushExample">
              <br />

              <p id="reg">
                <b>Inscvription</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading1">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse1"
                    aria-expanded="false"
                    aria-controls="flush-collapse1"
                  >
                    <b>Qu'est-ce que Hertz 24/7 ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse1"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading1"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Hertz 24/7® est le service d'autopartage Hertz® qui vous
                    offre la possibilité et la flexibilité d'accéder à une large
                    gamme de véhicules et véhicules utilitaires. Vous pouvez
                    louer à l'heure ou à la journée. La prise en charge est
                    possible 24h/24 et 7j/7 (sous réserve d'accessibilité des
                    parkings). Réservez et gérez facilement votre location via
                    l'application Hertz 24/7. Notre objectif, que vous soyez en
                    route dans les 15 minutes suivant le téléchargement de
                    l'application.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading2">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse2"
                    aria-expanded="false"
                    aria-controls="flush-collapse2"
                  >
                    <b>
                      Quelles sont les conditions requises pour pouvoir utiliser
                      Hertz 24/7 ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse2"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading2"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Pour utiliser Hertz 24/7, nous avons besoin des documents
                    suivants :<br />
                    • Un permis de conduire et une carte d’identité valides à
                    votre nom (ou un passeport et un justificatif de domicile)
                    <br />
                    • Une carte de crédit, une carte de débit ou un compte
                    PayPal à votre nom
                    <br />
                    • Votre numéro de téléphone portable et votre adresse e-mail
                    personnelle
                    <br />
                    Lors de votre inscription, nous effectuerons les
                    vérifications d’identité nécessaires avant de la confirmer.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading3">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse3"
                    aria-expanded="false"
                    aria-controls="flush-collapse3"
                  >
                    <b>Quel est l'âge minimum pour louer un véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse3"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading3"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vous devez avoir au moins 21 ans pour louer et conduire l'un
                    de nos véhicules. Vous devez également être titulaire d'un
                    permis de conduire valide depuis au moins un an.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading4">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse4"
                    aria-expanded="false"
                    aria-controls="flush-collapse4"
                  >
                    <b>Comment savoir si mon inscription est complète ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse4"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading4"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Une fois votre inscription entièrement finalisée, nous vous
                    enverrons une notification et un e-mail.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading5">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse5"
                    aria-expanded="false"
                    aria-controls="flush-collapse5"
                  >
                    <b>Que se passe-t-il si mes coordonnées changent ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse5"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading5"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vous pouvez modifier vos coordonnées à tout moment sur votre
                    profil dans l'application.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading7">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse7"
                    aria-expanded="false"
                    aria-controls="flush-collapse7"
                  >
                    <b>Mon abonnement Hertz 24/7 a-t-il une durée limitée ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse7"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading7"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Votre abonnement est illimité. Tant que votre permis de
                    conduire est valide et que vous respectez nos conditions
                    générales de location, vous pouvez utiliser Hertz 24/7.
                    <br />
                    D'autres termes et conditions peuvent s'appliquer.
                  </div>
                </div>
              </div>

              <br />
              <p id="book">
                <b>Votre réservation</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading9">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse9"
                    aria-expanded="false"
                    aria-controls="flush-collapse9"
                  >
                    <b>
                      Que se passe-t-il si le véhicule que je souhaite est déjà
                      réservé ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse9"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading9"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Si le véhicule que vous souhaitez réserver n’est pas
                    disponible aux dates souhaitées, une autre période vous sera
                    proposée. Vous pouvez également vérifier la disponibilité
                    sur un autre créneau horaire ou emplacement à proximité.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading10">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse10"
                    aria-expanded="false"
                    aria-controls="flush-collapse10"
                  >
                    <b>Comment savoir si ma réservation est confirmée ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse10"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading10"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vous pouvez consulter le statut de votre réservation dans
                    l’application Hertz 24/7. Nous vous enverrons également une
                    confirmation par e-mail.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading11">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse11"
                    aria-expanded="false"
                    aria-controls="flush-collapse11"
                  >
                    <b>
                      Comment serai-je facturé lors de la réservation d'une
                      location Hertz 24/7 ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse11"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading11"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Avant le début de la location, nous effectuons une
                    préautorisation d'un montant équivalent à 200 % du coût
                    estimé de la location, sur votre moyen de paiement. Ce
                    montant est bloqué et n'est pas débité. Il sert de dépôt de
                    garantie pour couvrir d'éventuels frais supplémentaires,
                    tels que des kilomètres supplémentaires ou un niveau de
                    carburant insuffisant. La préautorisation est levée lors de
                    l'émission de la facture. Nous déduisons les frais et vous
                    remboursons le solde. Si le coût de la location dépasse le
                    dépôt de garantie, nous prélèverons le montant excédentaire
                    sur votre moyen de paiement. Veuillez-vous assurer de
                    disposer de la totalité du montant, sans quoi la location ne
                    pourra pas commencer.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading12">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse12"
                    aria-expanded="false"
                    aria-controls="flush-collapse12"
                  >
                    <b>
                      Des frais sont-ils appliqués en cas de modification ou
                      d'annulation de ma réservation ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse12"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading12"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vous pouvez modifier votre réservation gratuitement jusqu'à
                    l'heure de prise en charge prévue. Vous pouvez annuler votre
                    réservation jusqu'à 6 heures avant l'heure de prise en
                    charge du véhicule, sans pénalité. Pour toute annulation
                    effectuée dans les 6 heures avant l’heure de prise en
                    charge, nous nous réservons le droit d'appliquer des frais
                    d'annulation.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading13">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse13"
                    aria-expanded="false"
                    aria-controls="flush-collapse13"
                  >
                    <b>Mon paiement est-il sécurisé ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse13"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading13"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Oui. Nous utilisons Stripe pour le traitement de tous les
                    paiements. Stripe respecte les normes de sécurité les plus
                    strictes du secteur, notamment un chiffrement des données
                    robuste (conforme à la norme PCI DSS). Nous respectons
                    toutes les lois applicables en matière de protection des
                    données personnelles et financières.
                    <br />
                    Veuillez noter que tout retard dans le remboursement du
                    dépôt de garantie est imputable à la banque émettrice de
                    votre carte de crédit ou de débit.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading14">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse14"
                    aria-expanded="false"
                    aria-controls="flush-collapse14"
                  >
                    <b>
                      Combien de temps à l'avance puis-je réserver un véhicule ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse14"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading14"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Selon le lieu, entre trois et six mois.
                  </div>
                </div>
              </div>

              <br />
              <p id="yj">
                <b>Votre location</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading15">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse15"
                    aria-expanded="false"
                    aria-controls="flush-collapse15"
                  >
                    <b>Comment trouver le véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse15"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading15"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Votre confirmation de réservation contient les informations
                    nécessaires pour trouver le véhicule. Ces informations sont
                    également disponibles dans l’application. Une fois votre
                    véhicule prêt, vous pourrez aussi le localiser grâce à la
                    fonction « Localisez le véhicule ».
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading16">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse16"
                    aria-expanded="false"
                    aria-controls="flush-collapse16"
                  >
                    <b>Comment déverrouiller le véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse16"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading16"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    L’application Hertz 24/7 est votre clé numérique. Pour
                    déverrouiller votre véhicule, appuyez sur le bouton
                    « Déverrouiller » dans l’onglet « Conduire » pendant votre
                    location. Remarque : vous ne pouvez déverrouiller le
                    véhicule qu’une fois la période de location officiellement
                    commencée, l’inspection terminée et le contrat signé.
                    Assurez-vous que la fonction "Bluetooth" de votre téléphone
                    est activée et que vous êtes à moins de 5 mètres du
                    véhicule. Si l’application ne parvient pas à se connecter
                    malgré l’activation du Bluetooth, veuillez-vous rendre dans
                    les « Paramètres » de l’application, recherchez Hertz 24/7
                    dans la section Applications et activez l’option Bluetooth.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading17">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse17"
                    aria-expanded="false"
                    aria-controls="flush-collapse17"
                  >
                    <b>Où puis-je trouver les clés ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse17"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading17"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vous trouverez les clés dans le véhicule, dans le porte-clés
                    situé dans la boîte à gants. Si elles ne s'y trouvent pas,
                    vérifiez les autres compartiments. Vous devrez également y
                    restituer les clés à la fin de votre location.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading18">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse18"
                    aria-expanded="false"
                    aria-controls="flush-collapse18"
                  >
                    <b>Comment démarrer le véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse18"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading18"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Sur la page "Conduire" demander la clé virtuelle puis, selon
                    le modèle, appuyez simultanément sur les pédales de frein et
                    d'embrayage puis sur le bouton de démarrage ou utilisez la
                    clé afin de démarrer. Si le véhicule ne démarre pas,
                    l'antidémarrage est peut-être activé. Dans l'application
                    Hertz 24/7, sur l'écran "Conduire", appuyez sur le bouton
                    "Ouvrir" pour désactiver l'antidémarrage, ou éventuellemnt
                    sur le bouton "Antidémarrage" si les portes sont déjà
                    ouvertes, le véhicule devrait alors démarrer. REMARQUE :
                    Certains véhicules électriques, comme les Tesla ou Polestar,
                    ne possèdent pas de bouton de démarrage séparé.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading19">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse19"
                    aria-expanded="false"
                    aria-controls="flush-collapse19"
                  >
                    <b>Que faire si le véhicule ne démarre pas ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse19"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading19"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Le véhicule est équipé d'un système de sécurité qui active
                    l'antidémarrage si le contact est coupé pendant plus de
                    2 minutes. Pour redémarrer le moteur avec l'antidémarrage
                    activé, retirez la clé du contact et utilisez l'application
                    pour désactiver l'antidémarrage en appuyant sur l'icône
                    "Antidémarrage" sur l'écran "Conduire" (l'icône située entre
                    les icônes de verrouillage et de déverrouillage). Vous
                    pouvez également verrouiller et déverrouiller le véhicule à
                    l'aide de l'application. Si le véhicule ne démarre toujours
                    pas, veuillez contacter notre service client.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading20">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse20"
                    aria-expanded="false"
                    aria-controls="flush-collapse20"
                  >
                    <b>
                      Que se passe-t-il si le véhicule que j'ai réservé n'est
                      pas là ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse20"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading20"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Veuillez utiliser la fonction "Localisez le véhicule" pour
                    localiser votre véhicule. Si vous ne le trouvez toujours
                    pas, veuillez contacter notre service client.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading21">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse21"
                    aria-expanded="false"
                    aria-controls="flush-collapse21"
                  >
                    <b>
                      Que se passe-t-il si je restitue le véhicule en retard ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse21"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading21"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Si vous pensez être en retard, veuillez prolonger votre
                    location via l’application. La prolongation est possible
                    uniquement s’il n’y a pas de réservation ultérieure et si le
                    parking est toujours ouvert à votre retour. Si vous dépassez
                    la durée de votre location sans l’avoir prolongée au
                    préalable, vous serez facturé pour le temps supplémentaire
                    utilisé et éventuellement de frais de retard.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading22">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse22"
                    aria-expanded="false"
                    aria-controls="flush-collapse22"
                  >
                    <b>
                      Le fait que je prenne le véhicule en retard a-t-il une
                      incidence ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse22"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading22"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Vous pouvez récupérer le véhicule à tout moment pendant la
                    période réservée. Cependant, la période de réservation
                    initiale sera tout de même facturée.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading23">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse23"
                    aria-expanded="false"
                    aria-controls="flush-collapse23"
                  >
                    <b>Qui prend en charge le carburant ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse23"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading23"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Le carburant est facturé sur la base d'un prix par
                    kilomètre, affiché au moment de la réservation. Tous les
                    véhicules doivent être munis d'une carte de carburant sous
                    le pare-soleil ou dans la boite a gant et d'au moins un
                    quart de réservoir au début de la location. Vous devez
                    également restituer le véhicule de cette manière. Si la
                    carte carburant est manquante au début de la location,
                    veuillez nous contacter en utilisant le Chat dans la section
                    Aide de l'application. La carte de carburant fournie est
                    limitée à 60€ par transaction. Les cartes carburant peuvent
                    être utilisées dans les stations-service du réseau DKV et le
                    code pin affiché dans l'application (sur la page "Conduire")
                    sera requis lors du paiement du carburant. Si la carte
                    carburant n’est pas présente dans le véhicule merci de faire
                    l’appoint en payant avec votre propre moyen de paiement nous
                    vous rembourserons sur justificatif, justificatif à envoyer
                    à l’adresse e-mail hertz247fr@hertz.com .
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading24">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse24"
                    aria-expanded="false"
                    aria-controls="flush-collapse24"
                  >
                    <b>
                      Que dois-je faire si j'ai dépassé la limite de la carte de
                      carburant ou si j'ai payé du carburant sans carte ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse24"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading24"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Lorsque vous faites le plein du véhicule, veillez à ne pas
                    dépasser la limite 60€ par transaction. Si vous dépassez la
                    limite, vous devrez payer vous-même le carburant. Vous
                    devrez envoyer le reçu par courriel au Service Client Hertz
                    24/7 afin de recevoir un remboursement pour le carburant que
                    vous avez payé vous-même. Veuillez noter que le traitement
                    de cette demande peut prendre plusieurs jours.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading25">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse25"
                    aria-expanded="false"
                    aria-controls="flush-collapse25"
                  >
                    <b>Fournissez-vous des sièges auto pour enfants ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse25"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading25"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non. Mais vous pouvez utiliser le vôtre.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading26">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse26"
                    aria-expanded="false"
                    aria-controls="flush-collapse26"
                  >
                    <b>
                      Puis-je restituer le véhicule avant la fin de la période
                      de location ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse26"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading26"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Oui, vous pouvez restituer le véhicule à tout moment pendant
                    cette période. Cependant, la totalité de la location vous
                    sera facturée.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading27">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse27"
                    aria-expanded="false"
                    aria-controls="flush-collapse27"
                  >
                    <b>Comment prolonger ma location ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse27"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading27"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Sous réserve de disponibilité du véhicule, vous pouvez
                    facilement prolonger votre location via l’application Hertz
                    24/7. Suivez les instructions après avoir appuyé sur le
                    bouton "Prolongez la location".
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading29">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse29"
                    aria-expanded="false"
                    aria-controls="flush-collapse29"
                  >
                    <b>Où dois-je restituer le véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse29"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading29"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Veuillez restituer le véhicule à l’aire de stationnement
                    Hertz 24/7 prévue à cet effet. S’il n’y a pas d’aire de
                    stationnement désignée, veuillez restituer le véhicule à
                    l’endroit où vous l’avez pris en charge.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading30">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse30"
                    aria-expanded="false"
                    aria-controls="flush-collapse30"
                  >
                    <b>
                      Que faire si la place de stationnement qui m'est attribuée
                      est déjà occupée ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse30"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading30"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Veuillez garer votre véhicule au plus près de votre place de
                    stationnement attribuée.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading31">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse31"
                    aria-expanded="false"
                    aria-controls="flush-collapse31"
                  >
                    <b>
                      Que se passe-t-il si le véhicule que j'ai réservé est
                      rendu en retard par le client précédent ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse31"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading31"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nous nous efforcerons toujours de vous contacter rapidement
                    pour vous en informer. Toutefois, si vous n'avez pas de
                    nouvelles de notre part, veuillez nous contacter au plus
                    vite afin que nous puissions vous proposer un autre
                    véhicule.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading32">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse32"
                    aria-expanded="false"
                    aria-controls="flush-collapse32"
                  >
                    <b>
                      Dois-je utiliser les clés pour verrouiller et
                      déverrouiller le véhicule ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse32"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading32"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Oui. Veuillez utiliser l'application Hertz 24/7 pour prendre
                    possession et restituer le véhicule, pendant toute votre
                    période de location vous pouvez utiliser la clé pour
                    fermer/ouvrir/démarrer le véhicule. En cas de problème pour
                    démarrer il se peut que l’antidémarrage se soit réactivé.
                    Pour le désactiver, veuillez appuyer sur le bouton
                    "Antidémarrage" de l'écran "Conduire" dans l'application.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading33">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse33"
                    aria-expanded="false"
                    aria-controls="flush-collapse33"
                  >
                    <b>Comment vos véhicules sont-ils entretenus ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse33"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading33"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Une équipe de professionnels dévoués prend soin de notre
                    flotte Hertz 24/7. Outre l’entretien régulier programmé,
                    nous effectuons un contrôle qualité en 40 points sur chaque
                    véhicule tous les mois.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading34">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse34"
                    aria-expanded="false"
                    aria-controls="flush-collapse34"
                  >
                    <b>Que faire en cas de panne ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse34"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading34"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Veuillez nous contacter en cas de panne. Vous trouverez nos
                    coordonnées dans l’application, sous Aide &gt; Contact.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading35">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse35"
                    aria-expanded="false"
                    aria-controls="flush-collapse35"
                  >
                    <b>Puis-je utiliser Hertz 24/7 dans d'autres pays ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse35"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading35"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Oui. Si vous êtes inscrit, vous pouvez actuellement utiliser
                    Hertz 24/7 au Royaume-Uni, en Allemagne, en Belgique, en
                    Italie, au Portugal et en France.
                  </div>
                </div>
              </div>

              <br />
              <p id="bfi">
                <b>Facturation, frais et assurance</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading47">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse47"
                    aria-expanded="false"
                    aria-controls="flush-collapse47"
                  >
                    <b>Y a-t-il des frais supplémentaires à prévoir ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse47"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading47"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Les frais supplémentaires, tels que les frais kilométriques
                    et d'assurance, seront affichés lors de la réservation. De
                    plus, des frais supplémentaires s'appliquent, notamment en
                    cas de retour tardif ou de défaut de ravitaillement ; vous
                    trouverez le détail de ces frais dans nos conditions
                    générales.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading45">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse45"
                    aria-expanded="false"
                    aria-controls="flush-collapse45"
                  >
                    <b>Dois-je payer une franchise ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse45"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading45"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    En cas de dommages, de perte ou de vol du véhicule, vous
                    devrez payer une franchise conformément à votre contrat
                    d’assurance souscrit lors de la réservation. Si le coût des
                    réparations est inférieur à la franchise, nous vous
                    rembourserons la différence, déduction faite des frais
                    administratifs.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading46">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse46"
                    aria-expanded="false"
                    aria-controls="flush-collapse46"
                  >
                    <b>Que couvre l'assurance lors de ma réservation ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapse46"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading46"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    L'assurance vous couvre pour les dommages causés au
                    véhicule, au-delà du montant de la franchise. La franchise
                    est le montant maximum que vous êtes tenu de payer en cas de
                    sinistre. Si vous respectez les conditions générales de
                    votre contrat de location, vous serez également protégé par
                    l'assurance responsabilité civile, qui est incluse en
                    standard et qui est exigée par la loi. Cette assurance vous
                    couvre pour les dommages causés aux autres véhicules, aux
                    autres biens et aux personnes blessées en cas d'accident. Si
                    la perte, les dommages ou le vol du véhicule sont causés
                    intentionnellement, si vous mettez le mauvais carburant dans
                    le véhicule, contaminez le réservoir de carburant ou le
                    réservoir AdBlue, ou endommagez les parties hautes du
                    véhicule, tous ces dommages seront considérés comme une
                    négligence grave et vous serez tenu de payer les frais de
                    réparation. Si le véhicule est volé, seul le montant de la
                    franchise vous sera facturé.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading48">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse48"
                    aria-expanded="false"
                    aria-controls="flush-collapse48"
                  >
                    <b>
                      Ai-je besoin d’options d’assurance comme la réduction de
                      franchise ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse48"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading48"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Bien que cela ne soit pas obligatoire, la plupart des
                    clients choisissent cette protection car elle offre une
                    tranquillité d’esprit totale. Elle vous couvre contre les
                    dommages coûteux. Cependant, des exceptions s’appliquent —
                    veuillez consulter les Conditions Générales pour plus de
                    détails.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-heading49">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapse49"
                    aria-expanded="false"
                    aria-controls="flush-collapse49"
                  >
                    <b>
                      Que se passe-t-il si je reçois une contravention pour
                      excès de vitesse ou stationnement ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapse49"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-heading49"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Les péages, les contraventions et les amendes pour
                    stationnemlent sont à votre charge et doivent être payés par
                    vous, auxquels s'ajoutent des frais administratifs.
                  </div>
                </div>
              </div>

              <br />
              <p id="aob">
                <b>Accidents/Pannes</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl51">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl51"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl51"
                  >
                    <b>Que faire en cas d'accident ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl51"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl51"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    En cas d'accident, si besoin, contactez immédiatement la
                    police. Ensuite, veuillez contacter sans délai l'équipe
                    Hertz 24/7 via les coordonnées indiquées dans la section
                    « Aide » de l'application. Nous nous chargerons de tout.
                    Veillez à noter les coordonnées de la tierce personne
                    impliquée dans l'accident et à prendre des photos des
                    dommages causés aux deux véhicules, si un tiers est
                    impliqué. Le fait de ne pas déclarer un accident peut
                    entraîner la nullité de votre couverture d'assurance.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl52">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl52"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl52"
                  >
                    <b>Que faire en cas de vol de mon véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl52"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl52"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    En cas de vol, veuillez nous contacter immédiatement via les
                    coordonnées indiquées dans l’application, dans la section
                    Aide &gt; Contact, et vous devrez faire une déclaration de
                    vol auprès des forces de l'ordre.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl53">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl53"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl53"
                  >
                    <b>
                      Dois-je payer des frais si mon véhicule est remorqué ou
                      mis en fourrière ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl53"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl53"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nous réglons d'abord les frais de remorquage et les amendes,
                    puis nous vous les facturons, auxquels s'ajoutent des frais
                    administratifs.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxln54">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexln54"
                    aria-expanded="false"
                    aria-controls="flush-collapsexln54"
                  >
                    <b>
                      Dois-je payer des frais de retour tardif si le véhicule
                      tombe en panne ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexln54"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxln54"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non. En cas de panne, vous n'aurez aucun frais
                    supplémentaire à payer (sauf si vous êtes responsable de la
                    panne). L'assistance routière d'urgence 24 h/24 est incluse
                    dans votre réservation.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxln55">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexln55"
                    aria-expanded="false"
                    aria-controls="flush-collapsexln55"
                  >
                    <b>
                      Mon assurance auto personnelle couvrira-t-elle les frais
                      de réparation ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexln55"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxln55"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non. Votre assurance auto personnelle ne couvre pas les
                    véhicules Hertz 24/7. Nos véhicules sont uniquement couverts
                    par les assurances que nous proposons ou fournissons dans le
                    cadre de votre réservation.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxln56">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexln561"
                    aria-expanded="false"
                    aria-controls="flush-collapsexln561"
                  >
                    <b>
                      Puis-je compter sur l'assurance de ma carte de crédit pour
                      couvrir les dommages ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexln561"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxln561"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Il est préférable de vérifier auprès de votre compagnie de
                    carte de crédit avant de réserver votre véhicule Hertz 24/7,
                    car les couvertures d'assurance varient d'une carte à
                    l'autre.
                  </div>
                </div>
              </div>
              <br />
              <p id="cg">
                <b>Règles de bonne conduite</b>
              </p>

              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl54">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl54"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl54"
                  >
                    <b>Dois-je nettoyer le véhicule avant de le restituer ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl54"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl54"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Oui. Veuillez-vous assurer que l’intérieur du véhicule est
                    propre à la fin de votre location, pour le confort du client
                    suivant.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxln55">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexln551"
                    aria-expanded="false"
                    aria-controls="flush-collapsexln551"
                  >
                    <b>
                      Que se passe-t-il si le véhicule n'est pas propre, à
                      l'intérieur comme à l'extérieur ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexln551"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxln551"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Nous demandons à nos clients de laisser le véhicule propre
                    et rangé à la fin de chaque location. Nous nettoyons
                    également les véhicules régulièrement. Toutefois, n'hésitez
                    pas à nous signaler tout problème concernant l'état du
                    véhicule. Vous pouvez également utiliser la fonction
                    « Signaler un problème » dans l'application.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxln56">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexln56"
                    aria-expanded="false"
                    aria-controls="flush-collapsexln56"
                  >
                    <b>Est-il permis de fumer dans le véhicule ?</b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexln56"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxln56"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non. Il est strictement interdit de fumer dans tous nos
                    véhicules. Des frais de nettoyage vous seront facturés si
                    nous constatons des traces de tabac dans le véhicule pendant
                    votre location.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxln57">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexln57"
                    aria-expanded="false"
                    aria-controls="flush-collapsexln57"
                  >
                    <b>
                      Puis-je amener des animaux de compagnie dans le véhicule ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexln57"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxln57"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Non. Les animaux de compagnie ne sont pas admis dans nos
                    véhicules, à l’exception des chiens d’assistance.
                  </div>
                </div>
              </div>
              <br />
              <p id="cls">
                <b>Contactez le support</b>
              </p>
              <div className="accordion-item">
                <h2 className="accordion-header" id="flush-headingxl71">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#flush-collapsexl71"
                    aria-expanded="false"
                    aria-controls="flush-collapsexl71"
                  >
                    <b>
                      Que se passe-t-il si je trouve quelque chose dans le
                      véhicule ou si j'y oublie quelque chose ?
                    </b>
                  </button>
                </h2>
                <div
                  id="flush-collapsexl71"
                  className="accordion-collapse collapse"
                  aria-labelledby="flush-headingxl71"
                  data-bs-parent="#accordionFlushExample"
                >
                  <div className="accordion-body">
                    Pas de souci. Contactez simplement notre équipe et nous vous
                    aiderons à retrouver l'objet oublié dans le véhicule. Si
                    vous trouvez quelque chose dans le véhicule nous
                    contacterons le locataire précédent.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row shadow-lg p-3 mb-5 bg-body rounded">
          <a href="https:/l.ead.me/beWm77">
            <img
              className="img-fluid rounded-4"
              src="https://images.hertz.com/content/dam/hod/images/en-gb/static/App_Banner-new-format%20FR.png"
              alt=""
              style={{
                width: "100vw",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            />
          </a>
        </div>
      </div>
    </>
  );
}

export default FAQBody;
